import { render } from "./DockerContainerToImage.vue?vue&type=template&id=087508b6"
import script from "./DockerContainerToImage.vue?vue&type=script&lang=js"
export * from "./DockerContainerToImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__